import { useEffect, useRef } from "react";

/** Isolates the browser page lifecycle from shared and native player code. */
export function usePlayerPageExit(onExit: () => void) {
  const callbackRef = useRef(onExit);
  callbackRef.current = onExit;
  useEffect(() => {
    const listener = () => callbackRef.current();
    globalThis.addEventListener("pagehide", listener);
    return () => globalThis.removeEventListener("pagehide", listener);
  }, []);
}
